module.exports = __webpack_public_path__ + "static/media/MTL_ASC_TNK1.119c62c5.png";